export * from './feed-descriptors';
